<template>
  <div class="text-center" style="padding: 16px;">
    <p class="mb-3">
      {{ $t("slideQRCodeAudience") }}
    </p>

    <div class="div-image-qrcode">
      <img :src="img" alt="" v-if="img">
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import Config from '@/config'

export default {
  data() {
    return {
      img: '',
    }
  },
  mounted() {
    const text =
      `${Config.audienceUrl}/${this.$store.state.presentation.uniqueAccessCode}`
    const self = this
    QRCode.toDataURL(
      text,
      { errorCorrectionLevel: 'Q', width: 800, margin: 1 },
      (err, url) => {
        self.img = url
      },
    )
  },
}
</script>

<style lang="scss" scoped>
p {
  font-size: 18px;
  margin-bottom: 8% !important;
}

.div-image-qrcode {
  max-width: 30%;
  margin: 0 auto;
}
img {
  max-width: 100%;
  width: 100%;
}

@media (max-width: 800px) {
  .div-image-qrcode {
    max-width: 30%;
  }
}
</style>
